'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _componentsTopMenu = require('../../components/TopMenu');

var _componentsTopMenu2 = _interopRequireDefault(_componentsTopMenu);

var _reactisModal = require('reactis-modal');

var _components = {
	_$App: {
		displayName: 'App'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var App = (function (_Component) {
	_inherits(App, _Component);

	function App() {
		_classCallCheck(this, _App);

		_Component.apply(this, arguments);
	}

	App.prototype.render = function render() {
		return _react2['default'].createElement(
			'div',
			null,
			_react2['default'].createElement(_reactisModal.ModalWindowContainer, null),
			_react2['default'].createElement(_componentsTopMenu2['default'], this.props),
			_react2['default'].createElement(
				'div',
				{ className: 'page-container' },
				_react2['default'].createElement(
					'div',
					{ className: 'page-content' },
					_react2['default'].createElement(
						'div',
						{ className: 'content-wrapper' },
						this.props.children
					)
				)
			)
		);
	};

	_createClass(App, null, [{
		key: 'propTypes',
		value: {
			children: _react.PropTypes.object.isRequired
		},
		enumerable: true
	}]);

	var _App = App;
	App = _wrapComponent('_$App')(App) || App;
	return App;
})(_react.Component);

exports['default'] = App;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/AppWithMenu.js
 ** module id = 963
 ** module chunks = 2
 **/